module.exports = __webpack_public_path__ + "img/hosting-solutionsimg-2.189791a8.png";